export default __webpack_public_path__ + "static/media/icone-pdf.1c01e614.png";